import Product from '../model/Product'

const CrossSellController = function ($scope, $timeout, Cart, CrossSell) {

  $scope.CrossSell = CrossSell;
  $scope.crossSellCheckboxLiveRegionProductName = '';
  $scope.crossSellCheckboxLiveRegionAction = '';
  var crossSellCheckboxLiveRegionTimeout = null;

  function announceCrossSellCheckboxStatus(productName, action) {
    $scope.crossSellCheckboxLiveRegionProductName = '';
    $scope.crossSellCheckboxLiveRegionAction = '';

    if (crossSellCheckboxLiveRegionTimeout) {
      $timeout.cancel(crossSellCheckboxLiveRegionTimeout);
    }

    crossSellCheckboxLiveRegionTimeout = $timeout(function () {
      $scope.crossSellCheckboxLiveRegionProductName = productName;
      $scope.crossSellCheckboxLiveRegionAction = action;
      crossSellCheckboxLiveRegionTimeout = null;
    }, 150);
  }

  $scope.showGiftwrapper = function (productCategory) {
    return CrossSell.moreGiftWrapperAllowed && $scope.isGiftWrapper(productCategory);
  };

  $scope.isGiftWrapper = function (productCategory) {
    return productCategory[ 'tags' ].indexOf('giftwrapper') !== -1;
  };

  $scope.showOptionsLayerByCategory = {};

  $scope.setShowOptionsLayer = function (productCategory, value) {
    $scope.showOptionsLayerByCategory[ productCategory.id ] = value;

    if (!value) {
      var section = document.getElementById('crosssell-' + productCategory.id);
      var isDesktop = window.innerWidth >= 800;
      var focusIndex = isDesktop ? 3 : 2;
      $timeout(function () {
        var articles = section ? section.querySelectorAll('article') : [];
        var control = null;
        var articleIndex = Math.min(focusIndex, articles.length - 1);

        while (articleIndex >= 0 && !control) {
          control = articles[ articleIndex ].querySelector('button:not([disabled]), input[type="checkbox"]:not([disabled])');
          articleIndex--;
        }

        if (control) {
          control.focus();
        }
      });
    }
  };

  CrossSell.showProductCategory = function (idOfProductCategories) {
    $scope.showOptionsLayerByCategory[ idOfProductCategories ] = true;
  };

  $scope.onProductClick = function (product, productCategory) {
    var wasChecked = Cart.cartHasProductID(product.id, productCategory.id);

    CrossSell.toggleCrossSellProduct(product, productCategory)
      .then(function () {
        announceCrossSellCheckboxStatus(
          product.name,
          wasChecked ? 'remove' : 'add'
        );

        var optionLayerIsShown = $scope.showOptionsLayerByCategory[ productCategory.id ];
        $scope.setShowOptionsLayer(
          productCategory, optionLayerIsShown
        );
      });
  };

  $scope.getSelectedProductId = function (productCategory) {
    var products = CrossSell.products[ productCategory.id ] || {};

    for (var key in products) {
      if (!products.hasOwnProperty(key)) {
        continue;
      }

      var product = products[ key ];
      if ($scope.isChecked(product, productCategory)) {
        return product.id;
      }
    }

    return null;
  };

  $scope.isInactiveProduct = function (product, productCategory) {
    var selectedProductId = $scope.getSelectedProductId(productCategory);

    return selectedProductId !== null && selectedProductId != product.id;
  };

  /**
   *
   * @see imgorientation
   * @param {Product} product
   * @param {string} modalId
   */
  $scope.onProductClickToShowModal = function (product, modalId) {
    /**
     * to set the orientation of the modal-images because the images was
     * loaded before modal is shown
     */
    angular.element('#' + modalId)
      .find('.images img')
      .each(function (index, element) {
        angular.element(element).trigger('load');
      });

    // to reset the amount and set it to wishes
    product.setAmountToWishes();
  };

  $scope.updateCart = function (product, productCategory, modalId) {
    if(modalId) {
      $scope.closeModal(modalId);
    }

    product.setWishesToAmount();

    if (product.getTotalWishCount() === 0) {
      for (var index in product.detailData.productsizes) {
        CrossSell.changeCrossSellProductAmount(product.id, productCategory.id, index, 0);
      }
      return CrossSell.removeSingleCrossSellProductFromCart(productCategory, product);
    } else {
      return CrossSell.addCrossSellProductToCart(product, productCategory);
    }
  };

  $scope.showProduct = function (product, productCategory, actualIndexInCategory, maxShow) {

    var optionLayerIsShown = $scope.showOptionsLayerByCategory[ productCategory.id ];
    var isChecked = $scope.isChecked(product, productCategory);

    var show = true;
    if (!isChecked && optionLayerIsShown
      && actualIndexInCategory > maxShow) {
      show = false;
    }

    return show;
  };

  $scope.showProductWithoutCartCheck = function (product, productCategory, actualIndexInCategory, maxShow) {

    var optionLayerIsShown = $scope.showOptionsLayerByCategory[ productCategory.id ];
    var isChecked = $scope.isChecked(product, productCategory);

    var show = true;
    if (!isChecked && optionLayerIsShown
      && (actualIndexInCategory > maxShow)) {
      show = false;
    }

    return show;
  };

  $scope.isChecked = function (product, productCategory) {
    var checked = Cart.cartHasProductID(product.id, productCategory.id);
    var input = document.getElementById('crosssell-' + productCategory.id + '-' + product.id);
    if (input) {
      checked = input.checked || checked;
    }
    return checked;
  };

  // initial status for the OptionsLayerByCategory
  for (var key in CrossSell.productCategories) {
    if (!CrossSell.productCategories.hasOwnProperty(key)) {
      continue;
    }
    var productCategory = CrossSell.productCategories[ key ];
    $scope.showOptionsLayerByCategory[ productCategory.id ] = true;
    if (Cart.haveProductsOfCategory(productCategory)) {
      $scope.setShowOptionsLayer(productCategory, true);
    }
  }

};


export default CrossSellController;
